import React, { useCallback, useEffect, useState } from "react";
import { useSdkContext } from "~/components/contexts";
import { enableAutoRenew } from "~/components/rosetta/api";
import { useGA4CommonParameters, useSendImpressionEvents } from "~/components/rosetta/hooks";
import { SubscriptionButton } from "~/components/rosetta/subscription-button/styles";
export const AutoRenewButton = ({
  className
}) => {
  const {
    handleTrackGA,
    handleTrackGA4,
    rosettaInstance
  } = useSdkContext();
  const {
    computeGA4CommonParameters
  } = useGA4CommonParameters();
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    if (rosettaInstance !== null && rosettaInstance !== void 0 && rosettaInstance.rulesEngine.getOutcome("user.autoRenewEnabled")) return;
    setShowButton(true);
  }, [rosettaInstance === null || rosettaInstance === void 0 ? void 0 : rosettaInstance.rulesEngine, handleTrackGA]);
  const {
    captureTrackImpressionEventTargetElement
  } = useSendImpressionEvents({
    ga4Event: useCallback(() => ({
      action: "imp",
      category: "subs",
      customized_parameters: {
        ...computeGA4CommonParameters(),
        call_to_action: "enable auto-renew",
        trigger_point: "masthead renewal button"
      },
      subcategory: "entry_point"
    }), [computeGA4CommonParameters]),
    gaEvent: useCallback(() => ({
      action: "Enable Auto Renew/Masthead/Impression",
      category: "Enable Auto Renew",
      label: window.location.href
    }), [])
  });
  if (!showButton) return null;
  return /*#__PURE__*/React.createElement(SubscriptionButton, {
    className: className,
    ref: captureTrackImpressionEventTargetElement,
    onClick: () => {
      const execute = async () => {
        handleTrackGA({
          action: "Enable Auto Renew/Masthead/Enable",
          category: "Enable Auto Renew",
          label: window.location.href
        });
        const autoRenewSubscriptionId = rosettaInstance === null || rosettaInstance === void 0 ? void 0 : rosettaInstance.rulesEngine.getOutcome("user.autoRenewSubscriptionId");
        handleTrackGA4({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...computeGA4CommonParameters(),
            call_to_action: "enable auto-renew",
            trigger_point: "masthead enable auto-renew button"
          },
          subcategory: "entry_point"
        });
        if (!autoRenewSubscriptionId) return;
        const result = await enableAutoRenew(autoRenewSubscriptionId);
        if (!result) return;
        window.postMessage({
          type: "PIANO_AUTORENEW_CONFIRMATION"
        }, "*");
        rosettaInstance === null || rosettaInstance === void 0 || rosettaInstance.rulesEngine.addRule(new rosettaInstance.Rule("user.autoRenewEnabled").priority(10).when(() => true).then(true));
        await (rosettaInstance === null || rosettaInstance === void 0 ? void 0 : rosettaInstance.rulesEngine.run());
        setShowButton(false);
      };
      void execute();
    },
    "data-qa": "auto-renew-button"
  }, "Enable Auto-renew");
};
AutoRenewButton.displayName = "AutoRenewButton";